export default "__VITE_ASSET__C6voZ$bv__"